import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import SelectPaginate from 'app/shared/components/select-paginate/SelectPaginate';
import { ICompany } from 'app/shared/model/company.model';
import { createEntity, getEntity, reset, updateEntity } from './company-token.reducer';

export const CompanyTokenUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);
  const [company, setCompany] = useState<ICompany>();

  const companyTokenEntity = useAppSelector(state => state.companyToken.entity);
  const loading = useAppSelector(state => state.companyToken.loading);
  const updating = useAppSelector(state => state.companyToken.updating);
  const updateSuccess = useAppSelector(state => state.companyToken.updateSuccess);

  const handleClose = () => {
    props.history.push('/company-token' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  useEffect(() => {
    if (companyTokenEntity.company?.id && !isNew) {
      setCompany(companyTokenEntity.company);
    }
  }, [companyTokenEntity]);

  const saveEntity = values => {
    const entity = {
      ...companyTokenEntity,
      ...values,
      company: company ?? companyTokenEntity,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    !isNew && {
      ...companyTokenEntity,
      companyId: companyTokenEntity?.company?.id,
    };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fleetSenseApp.companyToken.home.createOrEditLabel" data-cy="CompanyTokenCreateUpdateHeading">
            <Translate contentKey="fleetSenseApp.companyToken.home.createOrEditLabel">Create or edit a CompanyToken</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField hidden name="id" required readOnly id="company-token-id" label={translate('global.field.id')} validate={{ required: true }} />
              ) : null}
              <ValidatedField label={translate('fleetSenseApp.companyToken.token')} id="company-token-token" name="token" data-cy="token" type="text" />
              <div className="mb-3">
                <label data-tip data-for="companyTip">
                  {translate('fleetSenseApp.userCustom.company')}
                </label>
                <SelectPaginate apiUrl="api/companies" placeholder="" onChange={setCompany} value={company} valueName="name" isRequired />
              </div>
              <ValidatedField
                label={translate('fleetSenseApp.companyToken.activated')}
                id="company-token-activated"
                name="activated"
                data-cy="activated"
                check
                type="checkbox"
                className="mb-3"
                defaultChecked={true}
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/company-token" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default CompanyTokenUpdate;
